import React, { FC } from 'react';
import { LightHeader } from '../../../header/light/LightHeader';
import styles from './signup_up_layout.module.scss';

type Props = {
  header?: React.ReactNode;
};

export const SignUpLayout: FC<Props> = ({ children, header }) => (
  <>
    <LightHeader source="nav-signup">{header}</LightHeader>
    <div className={styles.layout}>{children}</div>
  </>
);
